<template>
  <div style="white-space: nowrap;">
    {{ t === 1 ? "(单选)" : t === 2 ? "(多选)" : "(不定项)" }}
  </div>
</template>

<script>
export default {
  name: "TopicType",
  props: {
    t: {
      //题目类型
      type: Number,
      default: 1
    }
  }
};
</script>
